import plugin from 'tailwindcss/plugin';

const wallpaper = plugin.withOptions(function () {
	return function ({ addComponents, e }) {
		const wallpaperBackgroundImage = `url('/assets/images/misc/diamond.png')`;

		addComponents({
			[`.${e('wallpaper')}`]: {
				backgroundImage: wallpaperBackgroundImage,
			},
		});
	};
});

export default wallpaper;
